import {
    PerguntaPesquisaSatisfacaoInicial,
    type PerguntaPesquisaSatisfacaoModel,
} from "../models/perguntaPesquisaSatisfacaoModel"
import {
    PerguntaPesquisaSatisfacaoActionsTypes,
    type PerguntaPesquisaSatisfacaoActionModel,
} from "./perguntaPesquisaSatisfacaoActions"

export function perguntaPesquisaSatisfacaoReducer(
    state: PerguntaPesquisaSatisfacaoModel,
    action: PerguntaPesquisaSatisfacaoActionModel
): PerguntaPesquisaSatisfacaoModel {
    switch (action.type) {
        case PerguntaPesquisaSatisfacaoActionsTypes.CARREGAR: {
            return {
                perguntas: action.payload,
                pendingDelete: [],
                _nextLocalId: action.payload.length + 1,
            }
        }

        case PerguntaPesquisaSatisfacaoActionsTypes.ADICIONAR: {
            const novaId = state._nextLocalId
            return {
                ...state,
                _nextLocalId: novaId + 1,
                perguntas: [
                    ...state.perguntas,
                    {
                        localId: novaId,
                        id: null,
                        descricao: "",
                        ordem: state.perguntas.length + 1,
                        tipo: 1,
                    },
                ],
            }
        }

        case PerguntaPesquisaSatisfacaoActionsTypes.REMOVER: {
            const { localId, dbId } = action.payload
            const encontrou = state.perguntas.some(p => p.localId === localId)
            if (!encontrou) return state
            return {
                ...state,
                perguntas: state.perguntas.filter(p => p.localId !== localId),
                pendingDelete:
                    dbId !== null && dbId > 0
                        ? [...state.pendingDelete, dbId]
                        : state.pendingDelete,
            }
        }

        case PerguntaPesquisaSatisfacaoActionsTypes.ATUALIZAR_CAMPO: {
            const { localId, campo, valor } = action.payload
            return {
                ...state,
                perguntas: state.perguntas.map(p =>
                    p.localId === localId ? { ...p, [campo]: valor } : p
                ),
            }
        }

        case PerguntaPesquisaSatisfacaoActionsTypes.CONFIRMAR_SAVE: {
            return {
                ...state,
                pendingDelete: [],
                perguntas: state.perguntas.map((p, i) => ({
                    ...p,
                    id: action.payload[i]?.id ?? p.id,
                })),
            }
        }

        default:
            return state
    }
}
